import { Component, Input } from '@angular/core';
import { DatagridService, NotificationService, PagedResultGeneric, PagedSearch, UtilService } from 'src/app/shared';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';
import { LazySelectableTableComponent } from 'src/app/shared/primeng/abstract-classes/lazy-selectable-table.component';
import { VerticalNaaService } from 'src/app/vertical/naa/shared/vertical-naa.service';
import { HbaNahbExportValidationDto } from 'src/app/vertical/nahb/shared/dto/hba-nahb-validation.dto';
import { VerticalNahbService } from 'src/app/vertical/nahb/shared/vertical-nahb.service';

@Component({
  selector: 'wl-nahb-export-validation-modal',
  templateUrl: './nahb-export-validation-modal.component.html',
  styleUrl: './nahb-export-validation-modal.component.less',
    standalone: false
})
export class NahbExportValidationModalComponent extends LazySelectableTableComponent<PagedSearch, HbaNahbExportValidationDto> {
  @Input() validationIssues: Array<HbaNahbExportValidationDto>;
  show: boolean = false;
  constructor(
    datagridService: DatagridService,
    private _utilService: UtilService,
    private _verticalNahbService: VerticalNahbService,
    private _navigationService: NavigationService,
    private _notificationService: NotificationService
  ) {
    super('', datagridService);
    this.searchResult = { PageSize: 20, CurrentPageNumber: 1 } as PagedResultGeneric<HbaNahbExportValidationDto>;
    this.searchParams = { PageNumber: 1, PageSize: 20 } as PagedSearch;
    this.preventInitialLoad = true;
  }

  public open() {
    this.show = true;
    this.search();
  }

  fetchResults(): Promise<PagedResultGeneric<HbaNahbExportValidationDto>> {
    return new Promise<PagedResultGeneric<HbaNahbExportValidationDto>>((resolve) => {
      if (this.searchParams.OrderBy) {
        let orderByStrings = this.searchParams.OrderBy.split(':');
        let sortedProperty = orderByStrings[0];
        let sortOrder = orderByStrings[1];
        if (sortOrder == 'asc') {
          this.validationIssues = this._utilService.sortByStringAsc(this.validationIssues, sortedProperty);
        } else {
          this.validationIssues = this._utilService.sortByStringDesc(this.validationIssues, sortedProperty);
        }
      }

      const startIndex = (this.searchParams.PageNumber - 1) * this.searchParams.PageSize;
      const endIndex = startIndex + this.searchParams.PageSize;

      const pagedData = this.validationIssues.slice(startIndex, endIndex);

      const pagedResult: PagedResultGeneric<HbaNahbExportValidationDto> = {
        Result: pagedData,
        TotalCount: this.validationIssues.length,
        TotalPages: Math.ceil(this.validationIssues.length / this.searchParams.PageSize),
        CurrentPageNumber: this.searchParams.PageNumber,
        PageSize: this.searchParams.PageSize,
      };

      resolve(pagedResult);
    });
  }

  pageSizeChanged() {
    this.searchParams.PageNumber = 1;
    this.search();
  }
  close() {
    this.show = false;
  }

  exportValidationIssues() {
    this._verticalNahbService
      .exportNahbValidation()
      .then((csvUrl) => {
        this._navigationService.popupSafeNavigate(csvUrl);
      })
      .catch((err) => {
        this._notificationService.httpError(err);
      });
  }
}
